import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import TeamLogo from './TeamLogo'

interface TeamCellProps {
  teamLogoSrc: string
  teamName: string
}

const StyledTeamCell = styled.div`
  ${({
    theme: {
      spacing: { spacing8 },
    },
  }) => css`
    display: grid;
    grid-template-columns: auto 1fr;
    grid-auto-flow: column;
    align-items: center;
    grid-column-gap: ${spacing8};
    width: 100%;
    min-height: 48px;
  `}
`

const StyledTeamName = styled.div`
  ${({
    theme: {
      color: {
        tertiary: { grey1000 },
      },
      typography: {
        headings: {
          xxsmall: { bundledCSS: xxsmallHeadingCSS },
        },
      },
      utils: { ellipsis },
    },
  }) => {
    return css`
      ${xxsmallHeadingCSS};
      color: ${grey1000};
      ${ellipsis('100%', 2)};
    `
  }}
`

const TeamCell: FunctionComponent<TeamCellProps> = ({
  teamLogoSrc,
  teamName,
}) => {
  return (
    <StyledTeamCell>
      <TeamLogo url={teamLogoSrc} name={teamName} />
      <StyledTeamName>{teamName}</StyledTeamName>
    </StyledTeamCell>
  )
}

export default TeamCell
